






























import { defineComponent, watch } from '@vue/composition-api';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { TP_QUICK_WITHDRAW_CARD_CARD_CATEGORY } from '../../tianqi';

// static component
// [功能说明]: 收款卡信息展示组件
interface BankCardInfo {
  userBankCardId?: string;
  bankName?: string;
  bankNo?: string;
  bankIconUrl?: string;
}

interface Props {
  label?: string;
  bankCardInfo?: BankCardInfo;
}

export default defineComponent({
  name: 'BankCardInfo',
  props: {
    label: {
      type: String,
      default: '收款卡',
    },
    bankCardInfo: {
      type: Object as () => BankCardInfo,
      default: () => ({
        userBankCardId: '',
        bankName: '',
        bankNo: '',
        bankIconUrl: '',
      }),
    },
  },
  setup(props: Props) {
    // 监听银行卡信息变化，触发曝光埋点
    watch(
      () => props.bankCardInfo,
      (newVal) => {
        // 当银行卡信息存在且显示时，触发曝光埋点
        if (newVal && newVal.userBankCardId) {
          ubtSetupModuleExpose(TP_QUICK_WITHDRAW_CARD_CARD_CATEGORY);
        }
      },
      { immediate: true },
    );
  },
});
